module.exports = __webpack_public_path__ + "img/Insuline.fab997f5.svg";